module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0145.jpg?v=a99f530e";